export class RuleErrors {
    static readonly errorMessages = [
        'TC.Common.TextExceedsLength',
        'TCS.TemplateEditor.Tf.Rules.ErrorMessages.PartOfCircularReference',
        'TCS.TemplateEditor.Tf.Rules.ErrorMessages.PartOfCircularReference',
        'TCS.TemplateEditor.Tf.Rules.ErrorMessages.ConditionNotComplete'
    ];
}
